
window.okeReviewsWidgetOnInit = function() {
    setUpHeader();
};

// Move reviews aggegrate and review button into control
function setUpHeader() {
    var reviewsControl = document.querySelector(".okeReviews-reviews-controls");
    var aggregateRating = document.querySelector(".okeReviews-reviewsAggregate-summary-rating");
    var reviewsCount = document.querySelector(".okeReviews-reviews-controls-reviewCount");
    var writeAReviewButton = document.querySelector(".js-okeReviews-writeReview");

    if (writeAReviewButton) {
        writeAReviewButton.innerText = "Leave a review";
    }

    if (aggregateRating) {
        aggregateRating.insertAdjacentElement("beforeend", reviewsCount);
    }

    if (reviewsControl) {
        reviewsControl.insertAdjacentElement("afterbegin", writeAReviewButton);
        reviewsControl.insertAdjacentElement("afterbegin", aggregateRating);
    }
}
